import { Quill } from 'react-quill';

const Block = Quill.import('blots/block')

class NoteTitle extends Block{}
NoteTitle.blotName = 'title'
NoteTitle.tagName = 'header'
NoteTitle.className = 'note-title'

Quill.register({'formats/title': NoteTitle})